export enum ExerciseTypes {
	LOAD_ALL_EXERCISE = 'LOAD/EXERCISES',
	LOAD_EXERCISE_FAIL = 'LOAD/EXERCISES?FAIL',
	LOAD_EXERCISE_BY_ID = 'LOAD/EXERCISE/BY/ID',
}
export type Tasks = {
	id:number;
	description:string;
}

export type Category =  {
	id: number;
	title: string;
}
export type Exercise = {
	id: number;
	title: string;
	imageName: string;
	frequency: string;
	Goal:string;
	whatToLookFor:string;
	skills:string;
	tip:string;
	minutes:string;
	supplies:string;
	Tasks: Tasks[] ,
	DevelopmentCategory: Category[],
	toyLink: string
};

export interface ExerciseListInterface {
	type: typeof ExerciseTypes.LOAD_ALL_EXERCISE;
	payload: Exercise[];
}
export interface ExerciseFailInterface {
	type: typeof ExerciseTypes.LOAD_EXERCISE_FAIL;
	payload: {
		errors: any | undefined;
	};
}
export interface ExerciseByIdInterface {
	type: typeof ExerciseTypes.LOAD_EXERCISE_BY_ID;
	payload: Exercise;
}

export type ExerciseDispatchTypes = ExerciseListInterface | ExerciseFailInterface | ExerciseByIdInterface;
